import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'

const quoteCSS = css`
  &:before {
    content: '\\201C';
    @apply text-white block -mb-6 text-5xl;
    @screen md {
      @apply text-6xl -mb-8;
    }
    @screen lg {
      @apply text-7xl -mb-12;
    }
  }
`

const Testimonial = ({ person, quote }) => {
  return (
    <blockquote className="text-white">
      <p className={`${quoteCSS} font-serif font-bold text-2xl md:text-3xl`}>
        {quote}
      </p>
      <footer className="mt-8">
        <p className="text-base md:text-lg italic">
          {person.name}
          {person.org ? ',' : ''}
        </p>
        {person.org && (
          <p className="mt-1 text-sm md:text-base">{person.org}</p>
        )}
      </footer>
    </blockquote>
  )
}

Testimonial.propTypes = {
  person: t.object,
  quote: t.string,
}

Testimonial.defaultProps = {}

export default Testimonial
